import React from 'react';

const CONFETTI_COLORS = [
  '#4c7cff',
  '#10504a',
  '#f0a04b',
  '#e85d75',
  '#7c5cfc',
  '#35c4a0',
  '#ff7a59',
  '#5ec8ff',
];
const CONFETTI_COUNT = 72;

/**
 * 화면 전체에 색종이가 흩날린 뒤 사라지는 축하 연출.
 * 튜토리얼 완료 연출(cp-tutorial-confetti)과 동일한 애니메이션을 공용 컴포넌트로 분리.
 */
const ConfettiBurst: React.FC<{ animKey?: string | number }> = ({ animKey }) => (
  <div className="cp-confetti-burst" key={animKey} aria-hidden>
    {Array.from({ length: CONFETTI_COUNT }, (_, i) => {
      const left = (i * 47 + (i % 9) * 13) % 100;
      const delay = (i % 18) * 55 + Math.floor(i / 12) * 40;
      const duration = 2100 + (i % 6) * 320;
      const drift = ((i * 17) % 160) - 80;
      const rot = 220 + (i % 8) * 120;
      const wobble = 18 + (i % 5) * 10;
      const top = -8 - (i % 10) * 2.2;
      const shape =
        i % 5 === 0 ? 'is-ribbon' : i % 3 === 0 ? 'is-square' : i % 4 === 0 ? 'is-round' : 'is-rect';
      return (
        <span
          key={i}
          className={`cp-confetti-piece ${shape}`}
          style={
            {
              left: `${left}%`,
              top: `${top}%`,
              '--d': `${delay}`,
              '--dur': `${duration}`,
              '--drift': `${drift}px`,
              '--wobble': `${wobble}px`,
              '--rot': `${rot}deg`,
              background: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
            } as React.CSSProperties
          }
        />
      );
    })}
  </div>
);

export default ConfettiBurst;
